import { Component, OnInit, ChangeDetectorRef } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Router } from "@angular/router";
import { BrokerService } from "../../services/broker.service";
import { StringService } from "../../services/string.service";
import { FormsModule } from "@angular/forms";

@Component({
  selector: "app-employee-list",
  templateUrl: "./employee-list.component.html",
  styleUrls: ["./employee-list.component.scss"],
  standalone: true,
  imports: [FormsModule],
})
export class EmployeeListComponent implements OnInit {
  public people: any[] = [];
  public query: string;

  constructor(
    private route: ActivatedRoute,
    public router: Router,
    private brokerService: BrokerService,
    public stringsService: StringService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.query = this.route.snapshot.paramMap.get("query");
    if (this.query) {
      this.search(this.query);
    }
  }

  searchSubmit() {
    this.search(this.query);
  }

  private search(query: string) {
    this.brokerService.search(query).subscribe({
      next: (result: any) => {
        this.people = result;
        this.cdr.detectChanges();
      },
      error: () => {
        this.people = [];
        this.cdr.detectChanges();
      },
    });
  }
}
